import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadPayAtom = createMutationAtomFactory(
  'trade.purchaseLoadPay',
  (params: { id: string }) => ({
    tradePurchaseLoadPay: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
